/** Persist list query so info "List" returns with filters. */
export const PURCHASE_LIST_SEARCH_KEY = "purchase-list-search";

export const getPurchaseListPath = () => {
  const q = sessionStorage.getItem(PURCHASE_LIST_SEARCH_KEY) || "";
  return `/purchase${q}`;
};

export const getPurchaseRowId = (record) =>
  record?.PurchaseNo ?? record?.purchase_no ?? record?.id;

/** PurchaseType comes back as 0/1 on detail and as a label ("On-site") on the list. */
export const isOnSitePurchaseType = (purchaseType) =>
  purchaseType === 0 ||
  purchaseType === "0" ||
  String(purchaseType ?? "")
    .toLowerCase()
    .replace(/[\s-]/g, "") === "onsite";

/** Unpaid pre-purchases are worked on in the pre-purchase page; everything else opens info. */
export const getPurchaseOpenPath = (purchase, canManagePurchase) => {
  const id = getPurchaseRowId(purchase);
  const isUnpaid =
    !(purchase?.PaymentTime != null && purchase?.PaymentTime !== "") &&
    !(purchase?.PaymentNo != null && purchase?.PaymentNo !== "");
  return canManagePurchase &&
    isUnpaid &&
    !isOnSitePurchaseType(purchase?.PurchaseType)
    ? `/purchase/prepurchase/${id}`
    : `/purchase/info/${id}`;
};
